<template>
  <div class="status_box">
    <div v-if="status === -1" class="status_desc">
      <span class="anim"></span>
      <span class="anim"></span>
      <span class="anim"></span>
      <span class="ani_text">审核中</span>
      <span class="anim"></span>
      <span class="anim"></span>
      <span class="anim"></span>
    </div>
    <div v-else-if="status === 0" class="status_desc warning">
      <i class="iconfont icon-cuowu"></i>
      <span>审核未通过</span>
    </div>
    <div v-else-if="status === 1" class="status_desc primary">
      <i class="iconfont icon-zhengque"></i>
      <span>审核通过</span>
    </div>
    <div v-else-if="status === 2" class="status_desc red">
      <i class="iconfont icon-jinggao"></i>
      <span>认证状态已过期，请重新提交审核</span>
    </div>
    <div v-else-if="status === -2" class="status_desc red">
      <i class="iconfont icon-jinggao"></i>
      <span>只能选择其中一种类型，请谨慎选择</span>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: 'CheckStatus',
  props: {
    status: { // 客户审核状态(-2:未提交资料(即游客客户,由前端定义的值),-1:审核中,0:审核未通过,1:审核通过(生效),2:认证已过期)
      type: Number,
      default: -2
    }
  }
}
</script>

<style lang="scss" scoped>
.status_box {
  margin: 20px;
  .status_desc {
    height: 40px;
    color: $main-color;
    font-size: 16px;
    text-align: center;
    line-height: 40px;
    border-radius: 4px;
    background-color: rgba(255, 57, 115, 0.05);
    &.primary {
      color: #6296FF;
      background-color: rgba(98, 150, 255, .05);
    }
    &.warning {
      color: #FF6D39;
      background-color: rgba(255, 109, 57, .05);
    }
    &.red {
      color: #D50000;
      background-color: rgba(255, 57, 115, .05);
    }
    .iconfont {
      margin-right: 6px;
    }
    .ani_text {
      margin: 0 2px 0 4px;
    }
  }
  .anim {
    display: inline-block;
    width: 8px;
    height: 12px;
    margin: 0 2px;
    transform: skewX(-30deg);
    background-color: $main-color;
    &:nth-child(1), &:nth-child(7) {
      opacity: .2;
      animation: fade 3s infinite;
    }
    &:nth-child(2), &:nth-child(6) {
      opacity: .2;
      animation: fade 3s infinite;
      animation-delay: 1s;
    }
    &:nth-child(3), &:nth-child(5) {
      opacity: .2;
      animation: fade 3s infinite;
      animation-delay: 2s;
    }
  }
}
@keyframes fade {
  0% {
    opacity: .2;
  }
  33% {
    opacity: .4;
  }
  66% {
    opacity: .6
  }
}
</style>